import { CldSourceMediaSize } from './../cld-picture/cld-picture.interface';
import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ExpLogoComponent } from '../exp-logo/exp-logo.component';
import { RouterLink } from '@angular/router';
import { CldPictureComponent } from '../cld-picture/cld-picture.component';
import { NgIf, NgTemplateOutlet, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
    selector: 'avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, CldPictureComponent, RouterLink, NgTemplateOutlet, NgSwitch, NgSwitchCase, ExpLogoComponent]
})
export class AvatarComponent implements OnInit {

  @Input() url: string;
  @Input() picture: string;
  @Input() sizes: CldSourceMediaSize[];
  @Input() fallbackImage: 'unknow-company' | 'unknow-user' | 'expometals' = 'unknow-user';
  constructor() { }

  ngOnInit() {

  }
}
